import { animate, scroll, inView, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const componentSimpleColumns = document.querySelectorAll('.component-simple-columns');

    // Check if the showcase block exists
    if (componentSimpleColumns.length === 0) {
        return;
    }

    componentSimpleColumns.forEach(component => {
        const componentSimpleColumnsColumns = component.querySelector('.component-simple-columns__columns');

        if (!componentSimpleColumnsColumns) {
            return;
        }

        // Animations
        inView(componentSimpleColumnsColumns, () => {
            // Animate the componentSimpleColumnsContent element
            animate(componentSimpleColumnsColumns.querySelectorAll('div'), 
                { 
                    opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                    transform: ['translateY(60px)', 'translateY(0)'], // Slide up (translateY transition).
                }, 
                { 
                    duration: 0.6, // Animation duration.
                    delay: stagger(0.3, { startDelay: 0.6 }) // Delay before animation starts.
                }
            );
        });
    });
});
